var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPins(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3469_8306)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.137297 15.1998C-0.0457656 15.3828 -0.0457656 15.6796 0.137297 15.8627C0.228797 15.9542 0.348766 16 0.468734 16C0.588703 16 0.708672 15.9542 0.800172 15.8627L5.55608 11.1068L4.89317 10.4438L0.137297 15.1998Z",
    fill: "#258E61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8626 3.97537L12.0245 0.137311C11.9097 0.0224043 11.7435 -0.0247832 11.5854 0.0125606C11.4272 0.0498731 11.2997 0.166404 11.2484 0.320529L10.6667 2.0654L13.9345 5.33315L15.6793 4.75153C15.8335 4.70015 15.95 4.57262 15.9873 4.41453C16.0247 4.2564 15.9774 4.09025 15.8626 3.97537Z",
    fill: "#258E61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1359 2.86035L6.7981 5.08557L10.9144 9.20191L13.1397 5.8641L10.1359 2.86035Z",
    fill: "#258E61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.96284 5.57599C5.51868 5.13183 4.92815 4.88721 4.30003 4.88721C3.6719 4.88721 3.08137 5.13183 2.63725 5.57599L2.32565 5.88758C2.14259 6.07064 2.14259 6.36743 2.32565 6.55049L9.44956 13.6744C9.54109 13.7659 9.66106 13.8117 9.78099 13.8117C9.90093 13.8117 10.0209 13.766 10.1124 13.6744L10.424 13.3628C10.8682 12.9187 11.1128 12.3281 11.1128 11.7C11.1128 11.0719 10.8682 10.4814 10.424 10.0372L5.96284 5.57599Z",
    fill: "#258E61"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3469_8306"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPins);
export default __webpack_public_path__ + "static/media/pins.8f0db6f683626508f1db55983c6d76b3.svg";
export { ForwardRef as ReactComponent };